<template>
  <el-dialog
    :visible.sync="isVisible"
    title="Importálás"
    :append-to-body="true"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-form>
      <el-row style="text-align: center">
        <el-col>
          <el-upload
            ref="upload"
            class="upload-demo"
            action=""
            accept=".csv"
            :limit="1"
            :multiple="false"
            :auto-upload="false"
            :on-change="onFileChange"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
              @click="onFileSelectClick"
            >
              Fájl kiválasztása
            </el-button>

            <el-button
              style="margin-left: 10px;"
              size="small"
              type="warning"
              @click="submitUpload"
            >
              Ellenőrzés
            </el-button>

            <el-button
              v-if="checkSuccessful"
              style="margin-left: 10px;"
              size="small"
              type="success"
              @click="importStart"
            >
              Importálás
            </el-button>

            <div
              class="el-upload__tip"
              slot="tip"
            >
              Kizárólag .csv kiterjesztésű fájl engedélyezett
            </div>
            <div v-if="error" style="text-align: center; color: red; padding: 5px;">
              {{ error }}
            </div>
          </el-upload>
        </el-col>
      </el-row>
      <el-row v-if="previewData.length > 0" style="text-align: center">
        <el-table
          :data="previewData"
          style="width: 100%"
          max-height="350"
        >
          <template v-for="(header, index) in headers">
            <el-table-column
              :key="`preview-column-${index}`"
              :fixed="index === 0"
              :prop="index.toString()"
              :label="header"
              width="150"
            />
          </template>
        </el-table>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleVisibility">
        Mégsem
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      isDialogVisible: {
        required: false,
        type: Boolean,
        default: false
      },
      storeModule: {
        required: true,
        type: String,
      }
    },
    data() {
      return {
        isVisible: this.isDialogVisible,
        file: {},
        previewData: [],
        headers: [],
        checkSuccessful: false,
        importType: '',
        error: '',
        id: null,
      };
    },
    computed: {
      isDisabled() {
        return Object.keys(this.file).length > 0
      }
    },
    watch: {
      isDialogVisible(newVal) {
        this.isVisible = this.isDialogVisible
      }
    },
    methods: {
      async submitUpload() {
        this.error = ''

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        let formData = new FormData();
        formData.append('file', this.file.raw);
        try {
          const response = await this.$store.dispatch(this.storeModule + '/getPreviewData', {
            formData: formData
          })

          this.previewData = response.data.preview
          this.headers = response.data.headers
          this.checkSuccessful = true;
          this.uploadedFile = response.data.file
          this.importType = response.data.type
          this.id = response.data.id
        } catch(error) {
          this.checkSuccessful = false;
          if (
            typeof error != 'undefined'
            && typeof error.data != 'undefined'
            && typeof error.data.errors != 'undefined'
            && typeof error.data.errors.file != 'undefined'
          ) {
            this.error = error.data.errors.file.join(', ')
          } else if (typeof error.message != 'undefined') {
            this.error = error.message
          }
          console.error(error)
        }
      },
      handleVisibility() {
        this.$emit('visibilityChanged')
        this.reset()
      },
      onFileChange(file) {
        this.file = file
      },
      onFileSelectClick() {
        this.$refs.upload.clearFiles()
        this.file={}
      },
      async importStart() {
        this.errorReset()
        try {
          const response = await this.$store.dispatch(this.storeModule + '/import', {
            id: this.id
          })

          this.handleVisibility()

        } catch(error) {
          this.checkSuccessful = false;
          if (
            typeof error != 'undefined'
            && typeof error.data != 'undefined'
            && typeof error.data.errors != 'undefined'
            && typeof error.data.errors.file != 'undefined'
          ) {
            this.error = error.data.errors.file.join(', ')
          } else if (
            typeof error != 'undefined'
            && typeof error.data != 'undefined'
            && typeof error.data.message != 'undefined'
            ) {
            this.error = error.data.message
          }
          console.error(error)
        }
      },
      reset() {
        this.dataReset()
        this.errorReset()
      },
      dataReset() {
        this.$refs.upload.clearFiles()
        this.file = {}
        this.previewData = []
        this.headers = []
        this.checkSuccessful = false
      },
      errorReset() {
        this.error = ''
      }
    }
  }
</script>
